const getLocations = (state) => {
  const resources = state.get('resources');
  if (!resources) return;
  return resources.get('locations');
};

const getAdmin = (state) => {
  const adminProperty = state.get('admin');
  if (!adminProperty) return;
  return adminProperty.get('admin');
};

const getPageSettings = (state) => {
  const pageSettings = state.getIn(['resources', 'pageSettings'], null);
  return pageSettings ? pageSettings.toJS() : null;
};

const isLoadingOrdersAnalytics = state => state.getIn(['loading', 'loadingOrdersAnalytics']);
const isLoadingDownloadsAnalytics = state => state.getIn(['loading', 'loadingDownloadsAnalytics']);

export {
  getPageSettings,
  getAdmin,
  getLocations,
  isLoadingOrdersAnalytics,
  isLoadingDownloadsAnalytics,
};
